import Autosuggest from 'react-autosuggest'
import { InputGroup, Glyphicon, Image, Row, Col } from 'react-bootstrap'
import styled from 'styled-components'
import Input from '../Subheader/Input'

const renderInput = (inputProps, clearHandler, highlight, inputRef) => (
  <InputGroup>
    <Input highlight={highlight} {...inputProps} ref={inputRef} />
    <InputGroup.Addon onClick={clearHandler}>
      <Glyphicon glyph={inputProps.value === '' ? 'search' : 'remove-circle'} />
    </InputGroup.Addon>
  </InputGroup>
)

const SuggestionItem = styled.div`
  padding: 10px;
  border-bottom: 1px solid var(--light-gray);
  font-size: 14px;
  z-index: 800;
`
const Title = styled.div`
  font-weight: 600;
`

const ImageContainer = styled.div`
  text-align: center;
  img {
    max-height: 40px;
    max-width: auto;
    display: inline;
  }
`

const renderSuggestion = (item) => (
  <SuggestionItem>
    <Row>
      {item.image_location && (
        <Col xs={3} md={3}>
          <ImageContainer>
            <Image
              alt="device"
              src={`https://s3.amazonaws.com/tpassets.devicebits.com${item.image_location}`}
              responsive
            />
          </ImageContainer>
        </Col>
      )}

      <Col xs={9} md={9}>
        <Title>{item.manufacturer}</Title>
        <div>{item.name}</div>
      </Col>
    </Row>
  </SuggestionItem>
)

const DeviceSearch = ({
  autosuggestProps,
  clearHandler,
  highlight,
  inputRef,
  submitHandler
}) => {
  return (
    <form onSubmit={submitHandler}>
      <Autosuggest
        {...autosuggestProps}
        renderSuggestion={renderSuggestion}
        renderInputComponent={(inputProps) =>
          renderInput(inputProps, clearHandler, highlight, inputRef)
        }
        focusInputOnSuggestionClick={false}
        shouldRenderSuggestions={() => true}
        id="device-autocomplete"
      />
    </form>
  )
}

export default DeviceSearch
